var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaTagUndNacht(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2,.cls-3{fill:none;}.cls-3{mix-blend-mode:lighten;opacity:0.5;}.cls-4{fill:#eaa224;}.cls-5{fill:#ddeaf1;}.cls-6{fill:#bddfff;}.cls-7{fill:#305895;}.cls-8{fill:#1b3558;}.cls-9{fill:#f2c136;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M8,34.33A26.08,26.08,0,1,1,34.07,60.47,26.14,26.14,0,0,1,8,34.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M125.14,88.06v63.75H34.07v-65h5.14l40.4-18.6L120,88.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M125.14,88.06v63.75H79.61V68.21L120,88.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 63.59,
    y: 109.3,
    width: 32.04,
    height: 37.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 79.61,
    y: 109.3,
    width: 16.02,
    height: 37.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M135.67,88.5l-4.74,9.13L79.61,70.82,28.29,97.63,23.54,88.5,79.61,59.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M135.67,88.5l-4.74,9.13L79.61,70.82V59.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M8,34.33A26.14,26.14,0,0,1,34.07,8.19V60.47A26.13,26.13,0,0,1,8,34.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M125.86,60.47a26.19,26.19,0,0,1-8.35-1.36,26.15,26.15,0,0,0,0-49.56,26.14,26.14,0,1,1,8.35,50.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.86,60.47c-.8,0-1.59,0-2.36-.11a26.14,26.14,0,0,0,0-52.06c.78-.07,1.57-.11,2.37-.11a26.14,26.14,0,0,1,0,52.28Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaTagUndNacht);
export default __webpack_public_path__ + "static/media/ka_tag-und-nacht.57ab3bd83ee330038ee05c6572d55012.svg";
export { ForwardRef as ReactComponent };